import { UseLoadingReturn } from "@/hooks/use-loading";
import workflowStepService from "@/services/workflow-steps";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type UseRemoveWorkflowStepReturn = {
  removeWorkflowStep: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveWorkflowStep = (): UseRemoveWorkflowStepReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (workflowStepId) => workflowStepService.delete(workflowStepId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    removeWorkflowStep: remove,
  };
};

export default useRemoveWorkflowStep;
